import { Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import {
    ApexAxisChartSeries,
    ApexChart,
    ChartComponent,
    ApexDataLabels,
    ApexPlotOptions,
    ApexYAxis,
    ApexLegend,
    ApexStroke,
    ApexXAxis,
    ApexFill,
    ApexTooltip,
    NgApexchartsModule,
    ApexGrid,
} from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    yaxis: ApexYAxis;
    xaxis: ApexXAxis;
    colors: string[];
    grid: ApexGrid;
    fill: ApexFill;
    tooltip: ApexTooltip;
    stroke: ApexStroke;
    legend: ApexLegend;
};

@Component({
    selector: 'app-new-tickets-created',
    standalone: true,
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        NgApexchartsModule,
    ],
    templateUrl: './new-tickets-created.component.html',
    styleUrl: './new-tickets-created.component.scss',
})
export class NewTicketsCreatedComponent {
    @ViewChild('chart') chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    @Input() data: any = {
        name: '',
        dates: [],
        series: [],
    };

    constructor() {
        this.chartOptions = {
            series: this.data.series,
            chart: {
                type: 'bar',
                height: 396,
                toolbar: {
                    show: true,
                },
            },
            plotOptions: {
                bar: {
                    columnWidth: '65%',
                    dataLabels: {
                        position: "top"
                    }
                },
            },
            dataLabels: {
                enabled: true,
                formatter: function(val) {
                    return val + "";
                },
                offsetY: -25,
                style: {
                    fontSize: "12px",
                    colors: ["#304758"]
                }
            },
            colors: ['#00FF00', '#FFFF00', '#FFA500', '#FF0000'],
            stroke: {
                width: 5,
                show: true,
                colors: ['transparent'],
            },
            xaxis: {
                categories: this.data.dates,
                axisBorder: {
                    show: false,
                    color: '#e0e0e0',
                },
                axisTicks: {
                    show: true,
                    color: '#e0e0e0',
                },
                labels: {
                    show: true,
                    style: {
                        colors: '#919aa3',
                        fontSize: '14px',
                    },
                },
            },
            yaxis: {
                labels: {
                    show: true,
                    style: {
                        colors: '#919aa3',
                        fontSize: '14px',
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            grid: {
                strokeDashArray: 5,
                borderColor: '#e0e0e0',
            },
            legend: {
                offsetY: 0,
                position: 'top',
                fontSize: '14px',
                horizontalAlign: 'center',
                labels: {
                    colors: '#919aa3',
                },
                itemMargin: {
                    horizontal: 10,
                    vertical: 0,
                },
            },
        };
    }

    // changeData
    changeData() {
        this.chartOptions.series = this.data.series;
        if (this.chartOptions.xaxis) {
            this.chartOptions.xaxis.categories = this.data.dates;
        }
        this.chartOptions.colors = [];
        this.data.series.forEach((element: any) => {
            this.chartOptions.colors?.push(element.color);
        });
    }
}
